export default __webpack_public_path__ + "static/media/service--site-internet.104536f9.webp";